import * as React from 'react';

import { HeroBanner } from '../../components/HeroBanner';
import { useIsReportStatusDefault } from '../../utils/report';
import { useBannerName } from './utils/useBannerName';
import { useSelector } from 'react-redux';
import { selectIsCalculatorPage } from '../../selectors/page';

export const HeroBannerContainer: React.FC = () => {
  const isReportStatusDefault = useIsReportStatusDefault();
  const isCalculatorPage = useSelector(selectIsCalculatorPage);
  const backgroundFor = useBannerName();

  /** Баннер не рендерится на агентской странице, если статус отчета отличается от Default */
  if (!isCalculatorPage && !isReportStatusDefault) {
    return null;
  }

  return <HeroBanner backgroundFor={backgroundFor} />;
};

HeroBannerContainer.displayName = 'HeroBannerContainer';
